var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._v("\n  jjjj\n  "),_c('el-input',{attrs:{"placeholder":_vm.column.placeholder ? _vm.column.placeholder : '请选择' + _vm.column.label},model:{value:(_vm.value),callback:function ($$v) {_vm.value=$$v},expression:"value"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }